import React, {PureComponent} from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import InputPrompt from 'components/input_prompt/input_prompt'
import { myLibrarySelectors } from 'redux/selectors'
import myLibraryActions from 'redux/actions/my_library_actions'
import { localize } from 'helpers/translator'

const FolderIcon = <svg height="25px" width="25px" viewBox="0 0 19 14"> <path d="M18.49 2.06H8.02L5.97.16C5.85.06 5.71 0 5.56 0H.71C.37 0 0 .17 0 .51v12.77c0 .34.37.72.71.72h17.78c.34 0 .51-.38.51-.72V2.57c0-.34-.17-.51-.51-.51z" fill="#5FD598"/> <path d="M12.92 5.08v2.735h2.735v.79H12.92v2.735h-.79V8.605H9.394v-.79h2.734V5.08h.79z" fill="#FFF"/> </svg>

class PrivateLibraryNameFolderModal extends PureComponent {

	constructor(props) {
		super(props)
		this.state = {
			folder_name: props.value || '',
			status: '',
		}
	}

	inputChangeHandler = e => {
		e.preventDefault()
		this.setState({
			folder_name: e.target.value,
			status: '',
		})
	}

	submitFolder = () => {
		if (!this.state.folder_name || this.props.submitting) {
			return
		}
		this.props.actions.addOrUpdateFolder(this.props.folderUID, this.state.folder_name, this.props.lesson, this.props.parentFolder)
	}

	componentWillReceiveProps(newProps) {
		if (newProps.status !== this.props.status) {
			this.setState({
				status: newProps.status,
			})
		}
	}

	render() {

		const props = this.props

		const placeholder = localize('my_library_name_folder_modal_placeholder_2')
		const titleText = localize('my_library_name_folder_modal_title')
		let mainButtonText
		if (this.props.submitting) {
			mainButtonText = this.props.folderUID === '0' ? localize('my_library_name_folder_modal_creating') : localize('my_library_name_folder_modal_renaming')
		} else {
			mainButtonText = this.props.folderUID === '0' ? localize('global_create') : localize('my_library_name_folder_modal_rename')
		}

		return (
			<InputPrompt
				modalName={props.modalName}
				placeholder={placeholder}
				titleText={titleText}
				titleIcon={FolderIcon}
				message={props.message}
				status={this.state.status}
				value={this.state.folder_name}
				autoFocus={true}
				cancelButtonText={localize('global_cancel')}
				mainButtonText={mainButtonText}
				mainButtonDisabled={!this.state.folder_name}
				closeAction={props.actions.cancelNameFolder}
				onEnterKeyHandler={this.submitFolder}
				onChangeHandler={this.inputChangeHandler}
				cancelButtonClickHandler={props.actions.cancelNameFolder}
				mainButtonClickHandler={this.submitFolder} />
		)
	}

}

function mapStateToProps(state) {
	return myLibrarySelectors.myLibraryFolderEditSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: generalActions.closeModal,
		addOrUpdateFolder: myLibraryActions.addOrUpdateFolder,
		cancelNameFolder: myLibraryActions.cancelAddOrUpdateFolder,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PrivateLibraryNameFolderModal)
